<div class="container-fluid">
	<h3>Customer Web Searches</h3>
	<form [formGroup]="searchForm">
	<div class="row">
		<div class="col-3">
			<mat-form-field appearance="outline">
				<mat-label>Show Zero Results</mat-label>
					<mat-select formControlName="onlyzero">
						<mat-option value="0">
						Show All Results
						</mat-option>
						<mat-option value="1">
						Show Only Zero Results
						</mat-option>
						<mat-option value="2">
						Hide Zero Results
						</mat-option>
					</mat-select>
			</mat-form-field>
		</div>
		<div class="col-3">
			<mat-form-field appearance="outline">
				<mat-label>Keyword</mat-label>
				<input matInput formControlName="keywords">
			</mat-form-field>
		</div>
		<div class="col-3">
			<mat-form-field appearance="outline">
				<mat-label>Customer Name</mat-label>
				<input matInput formControlName="name">
			</mat-form-field>
		</div>
		<div class="col-3">
			<mat-form-field appearance="outline">
				<mat-label>IP Address</mat-label>
				<input matInput formControlName="ip">
			</mat-form-field>
		</div>
	</div>
	<div class="row">
		<div class="col-3">
			<mat-form-field appearance="outline" class="w-100 strpt-field">
				<mat-label>Search Dates</mat-label>
				<mat-date-range-input [rangePicker]="searchPicker">
					<input matStartDate formControlName="startdate" placeholder="Start" />
					<input matEndDate formControlName="enddate" placeholder="End" />
				</mat-date-range-input>
				<mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
				<mat-datepicker-toggle matSuffix [for]="searchPicker"></mat-datepicker-toggle>
				<mat-date-range-picker #searchPicker></mat-date-range-picker>
			</mat-form-field>
		</div>
		<div class="col-3">
			<mat-form-field appearance="outline">
				<mat-label>Result Limit</mat-label>
					<mat-select formControlName="limit">
						<mat-option value="100">
						100 Rows
						</mat-option>
						<mat-option value="500">
						500 Rows
						</mat-option>
						<mat-option value="1000">
						1000 Rows
						</mat-option>
					</mat-select>
			</mat-form-field>
		</div>
		<div class="col-6">
			<ng-container *ngIf="!searching">
			<button class="btn btn-primary" (click)="searchsearch()"><mat-icon>search</mat-icon> Refresh </button>
			<button *ngIf="searchresults.length > 0 && !generating" class="btn btn-danger" (click)="exportPdf()"><i class="fa fa-file-pdf-o"></i> PDF </button>
			<button *ngIf="searchresults.length > 0 && !generating" class="btn btn-success" (click)="exportXls()"><i class="fa fa-file-excel-o"></i> XLS </button>
			<button class="btn btn-warning" (click)="runAiReport()"><mat-icon>computer</mat-icon> AI Analysis </button>
			
			</ng-container>
			<ng-container *ngIf="generating">
			<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
				<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
			</svg>
			Generating file...
			</ng-container>
			<ng-container *ngIf="searching">
			<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
				<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
			</svg>
			</ng-container>
		</div>
		
	</div>
	</form>
	<div class="row" *ngIf="aiText != ''">
	<span class="danger" *ngIf="aiError != ''">
	{{aiError}}
	</span>
	<div [innerHtml]="aiText" class="ai-results">
	</div>
	</div>
	<div class="row" >
	<div class="table w-100" #print_table>
		<table class="table table-striped table-hover table-bordered">
			<thead class="thead-dark">
				<tr>
					<th scope="col">Keywords</th>
					<th scope="col">Products</th>
					<th scope="col">Customer</th>
					<th scope="col">IP Address</th>
					<th scope="col">Timestamp</th>
					
				</tr>
			</thead>
			<tbody>
				<tr *ngIf="searchresults.length == 0">
					<td colspan="5">
					No Search Results Found
					</td>
				</tr>
				<tr *ngFor="let s of searchresults">
					<td>{{ s.keyword }}</td>
					<td>{{s.products}}</td>
					<td>{{ s.name }}</td>
					<td>{{s.ip}}</td>
					<td>{{ s.date_added | date: 'shortDate' }}</td>
				</tr>
			</tbody>
		</table>
		</div>
	</div>
</div>